import axios from 'axios';
import { BASE_URL } from '../appConfig';

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  },
  withCredentials: true
});

api.interceptors.request.use(
  config => {
    // if headers doesn't contain token
    if (config.headers && config.headers.Authorization) return config;
    // add token from local storage
    config.headers.Authorization = `Bearer ${localStorage.getItem(
      'access_token'
    )}`;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default api;



// WEBPACK FOOTER //
// ./src/services/api.js